// extracted by mini-css-extract-plugin
export default {"mask":"itemMask_mask__BQvpY"};